var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('sr-open-assessments',{attrs:{"rubricId":_vm.rubric.id,"title":_vm.title,"routeName":"AssessmentHome","hideHeaders":true,"routeProps":{ query: { rubricId: _vm.rubric.id } },"headers":_vm.headers,"query":_vm.query}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }